export enum OrderEnum {
  DESC = "desc",
  ACS = "asc",
}
